export default "__VITE_ASSET__DDN5wCdt__"